'use client';

export { default } from './Slider';
export * from './Slider';
export { default as sliderClasses } from './sliderClasses';
export * from './sliderClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Slider/index.js
// module id = 877
// module chunks = 22